import React from 'react';

const Unauthorized = () => (
    <div>
        <h1>Unauthorized</h1>
        <p>You do not have access to view this page.</p>
    </div>
);

export default Unauthorized;
